'use strict';

import angular from 'angular';
import SimpleMessages from '../../../controllers/simple-messages';

class ItemController {
    /* @ngInject */
    constructor(
        ItemsService,
        $mdDialog,
        $mdToast,
        $timeout,
        $scope
    ) {
        Object.assign(this, {
            ItemsService,
            $mdDialog,
            $mdToast,
            $timeout,
            $scope
        });

        $scope.$on(
            'associationSave',
            ($event, itemId) => this.onAssociationSave(itemId)
        );
        $scope.$on('associationCancel', () => this.onAssociationCancel());
        $scope.$on('associationStart', () => this.onAssociationStart());
        this.associatedAmount = 0;
    }

    $onInit() {
        this.originalCost = this.model.finalCost;
    }

    updateAssociatedAmount() {
        this.model.finalCost = this.originalCost + this.associatedAmount;
        this.onUpdateAssociatedAmount({
            $event: {
                model: this.model,
                associatedAmount: this.associatedAmount
            }
        });

        if (this.model.finalCost > this.model.finalPrice) {
            let confirm = this.$mdDialog.confirm()
                .title('Desea aumentar el Final?')
                .textContent(`El gasto ingresado hace que el total de gastos \
del item sea mayor que el monto final del item. Desea aumentar el monto final
del item para que iguale a los gastos?`)
                .ok(`Sí, aumentar el Final`)
                .cancel('No, dejarlo como está');

            return this.$mdDialog.show(confirm).then(() => {
                this.model.finalPrice = this.model.finalCost;
                this.save();
            });
        }
    }

    onAssociationCancel() {
        this.model.finalCost = this.originalCost;
        this.associatedAmount = 0;
    }

    onAssociationSave(itemId) {
        console.debug('onAssociationSave', itemId);
        if (itemId == this.model.id) {
            this.originalCost = this.model.finalCost;
            this.associatedAmount = 0;
        }
    }

    onAssociationStart() {
        this.originalCost = this.model.finalCost;
        this.associatedAmount = 0;
    }

    save() {
        let promise = this.ItemsService.save(this.model);
        this.showSpinner = true;
        promise.then(() => {
            this.showSpinner = false;
            this.showSaveCheck = true;

            this.$timeout(() => {
                this.showSaveCheck = false;
            }, 1000);
        });
        this.onSave({
            $event: {
                model: this.model,
                promise: promise
            }
        });
    }

    delete(ev) {
        var confirm = this.$mdDialog.confirm()
            .title('Confirmacion')
            .textContent(`Desea realmente eliminar el item ${this.model.name}?`)
            .ariaLabel('Lucky day')
            .targetEvent(ev)
            .ok('Si, eliminar')
            .cancel('Cancelar');

        this.$mdDialog.show(confirm).then(() => {
            let promise = this.ItemsService.destroyById(this.model.id)
                .then(() => {
                    this.simpleSuccess('Item eliminado correctamente');
                }, err => {
                    this.simpleError();
                });
            this.markedForDeletion = true;
            this.model.markedForDeletion = true;
            this.onDelete({
                $event: {
                    model: this.model 
                }
            });
        });
    }
}

Object.assign(ItemController.prototype, SimpleMessages);
export default ItemController;
